import React from "react";
import { Button, Box, Text } from "@mantine/core";
import CustomCheckbox from "./CustomCheckbox";
import { DEFAULT_THEME } from "../../shared/util/consts";
import { ThemeType } from "../../shared/util/types";
import { MultipleChoiceButtonInterface } from "./MultipleChoiceButtons";

type MultipleChoiceMultipleSelectProps = {
  instructions?: string;
  subInstructions?: string;
  options: MultipleChoiceButtonInterface[];
  theme?: ThemeType;
  onSubmit: (selectedOptions: string[]) => void;
  maxSelections?: number;
  submitButtonText?: string;
  submitButtonStyle?: React.CSSProperties;
};

const MultipleChoiceMultipleSelect: React.FC<
  MultipleChoiceMultipleSelectProps
> = ({
  instructions,
  subInstructions,
  options,
  theme = DEFAULT_THEME,
  onSubmit,
  maxSelections = options.length,
  submitButtonText = "Submit Selected Options",
  submitButtonStyle = {},
}) => {
  const defaultStyle: React.CSSProperties = {
    backgroundColor: theme.BackgroundColor,
    color: theme.TextColor,
    //font: theme.Font,
    fontSize: "16px",
    border: "1px solid #fff",
    borderRadius: "5px",
    width: "50%",
    minWidth: "300px",
    marginTop: "10px",
    padding: "10px",
    minHeight: "50px",
    height: "auto",
    alignItems: "center",
    display: "flex",
    justifyContent: "flex-start",
  };
  const [selectedOptions, setSelectedOptions] = React.useState<string[]>([]);
  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
      }}
    >
      {instructions && (
        <Text
          style={{
            color: theme.TextColor,
            fontSize: "24px",
            justifyContent: "center",
            display: "flex",
            textAlign: "center",
          }}
        >
          {instructions}
        </Text>
      )}
      {subInstructions && (
        <Text
          style={{
            color: theme.ReminderColor,
            fontSize: "18px",
            marginTop: "10px",
            justifyContent: "center",
            display: "flex",
            textAlign: "center",
          }}
        >
          {subInstructions}
        </Text>
      )}
      {options.map((option, index) => (
        <Box
          key={index + "box"}
          style={{
            ...defaultStyle,
            ...option.style,
          }}
          onClick={() => {
            if (
              !selectedOptions.includes(option.value) &&
              selectedOptions.length < maxSelections
            ) {
              setSelectedOptions([...selectedOptions, option.value]);
            } else {
              setSelectedOptions(
                selectedOptions.filter((opt) => opt !== option.value),
              );
            }
          }}
        >
          <CustomCheckbox
            checked={selectedOptions.includes(option.value)}
            size="large"
          />
          {option.text}
        </Box>
      ))}
      <Button
        onClick={() => {
          onSubmit(selectedOptions);
          setSelectedOptions([]);
        }}
        style={{
          ...defaultStyle,
          ...submitButtonStyle,
          marginTop: "20px",
          justifyContent: "center",
        }}
      >
        {submitButtonText}
      </Button>
    </Box>
  );
};

export default MultipleChoiceMultipleSelect;
